import { Button, Column, Grid } from "@carbon/react";
import { ArrowRight } from "@carbon/react/icons";
import { Link } from "react-router-dom";

export const View = ({
  // left side
  iconSource,
  pageTitle,
  pageSubtitle,
  pageDescription,

  // right side
  hideLink,
  linkTitle,
  linkSubtitle,
  linkButtonText,
  linkButtonUrl,
  linkButtonAction,
  linkButtonIcon,
  linkButtonIconLeft,
  linkButtonClassName = "",
}) => {
  return (
    <div className="page-banner--container">
      {iconSource ? (
        <div className="page-banner--icon">
          <img
            src={iconSource}
            alt="page banner icon"
            className="page-banner--large-icon"
          />
        </div>
      ) : (
        <></>
      )}

      <Grid fullWidth>
        <Column sm={4} md={5} lg={12}>
          <div>
            <p className="page-banner--header">
              <strong>{pageTitle}</strong>
            </p>

            <p className="page-banner--subheader">
              <strong>{pageSubtitle}</strong>
            </p>

            <p className="page-banner--description">{pageDescription}</p>
          </div>
        </Column>

        {!hideLink && (
          <Column
            sm={4}
            md={8}
            lg={{ span: 4, offset: 12 }}
            className="page-banner--brand-ad"
          >
            <p>
              <strong>{linkTitle}</strong>
            </p>

            <p className="switchapp-small">{linkSubtitle}</p>

            {/* <Link to={linkButtonUrl}>
              {linkButtonText}
              <ArrowRight />
            </Link> */}

            <Button
              size="sm"
              kind="tertiary"
              className={`switchapp-themed setup-button ${linkButtonClassName}`}
              renderIcon={() =>
                linkButtonIconLeft ? <></> : linkButtonIcon || <ArrowRight />
              }
              onClick={linkButtonAction}
            >
              {linkButtonIconLeft ? linkButtonIcon || <ArrowRight /> : <></>}
              {linkButtonText}
            </Button>
          </Column>
        )}
      </Grid>
    </div>
  );
};
